import { getStorefrontApiClient } from './client';
import type { GetThemeVersions, TriggerThemeDeploy, GetPipelineStatus } from './types';

// ps-storefront-api serves plain JSON (not json:api), so the axios `.data` is the contract object
// directly — no `.data.data` envelope to unwrap.

export const getThemeVersions: GetThemeVersions = async (partnerCode) => {
  const api = await getStorefrontApiClient();
  const { data } = await api.getThemeVersions(partnerCode);
  return data;
};

export const triggerThemeDeploy: TriggerThemeDeploy = async (partnerCode, selector) => {
  const api = await getStorefrontApiClient();
  const { data } = await api.triggerLiquidPipeline(partnerCode, { selector });
  return data;
};

export const getPipelineStatus: GetPipelineStatus = async (partnerCode, uuid) => {
  const api = await getStorefrontApiClient();
  const { data } = await api.getPipelineStatus(partnerCode, uuid);
  return data;
};
